import React from 'react';
import { formatHHMM } from './timelineGeometry';

/**
 * TVPreview — bottom-left bar showing the dashboard resolver's verdict at
 * the current playhead. "What this screen would be playing right now."
 *
 * Cosmetic. Authoritative playback still runs off the backend timeline.
 */
export default function TVPreview({ playheadMinutes, result }) {
  const mode = result?.mode || 'empty';
  const clips = Array.isArray(result?.clips) ? result.clips : [];
  const winner = result?.winner || null;

  let body;
  if (mode === 'empty') {
    body = <div className="timeline-editor__tv-preview-empty">— nothing scheduled —</div>;
  } else if (mode === 'loop') {
    body = (
      <div className="timeline-editor__tv-preview-playing">
        <div className="timeline-editor__tv-preview-title">Looping</div>
        <div className="timeline-editor__tv-preview-sub">
          {clips.map((c) => c.name).join(' · ')}
        </div>
      </div>
    );
  } else {
    // 'solo' (or any legacy mode) — show the single active clip.
    body = (
      <div className="timeline-editor__tv-preview-playing">
        <div className="timeline-editor__tv-preview-title">{winner?.name || '—'}</div>
      </div>
    );
  }

  return (
    <div className={`timeline-editor__tv-preview timeline-editor__tv-preview--${mode}`}>
      <div className="timeline-editor__tv-preview-header">
        <span className="timeline-editor__eyebrow">Now playing (preview)</span>
        <span className="timeline-editor__tv-preview-time">
          {formatHHMM(playheadMinutes)}
        </span>
      </div>
      <div className="timeline-editor__tv-preview-body">{body}</div>
    </div>
  );
}
